import { defineMessages } from 'react-intl';

export default defineMessages({
  myAccount: {
    id: 'organization-select.myAccount',
    defaultMessage: 'My Account'
  }
})
